// React
import React from "react";
//-------------------------------------------------------------------------------------------------------------------------------
// Styles
//-------------------------------------------------------------------------------------------------------------------------------
import styles from "./ComponentLoading.less";
//-------------------------------------------------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------------------------------------------------
export default class ComponentLoading extends React.Component {
    render() {
        let containerStyles = null;
        if (this.props.height) {
            if (containerStyles) {
                containerStyles.height = this.props.height;
            }
            else {
                containerStyles = { height: this.props.height };
            }
        }
        return (React.createElement("div", { className: styles.loaderContainer, style: containerStyles },
            React.createElement("div", { className: styles.centering },
                React.createElement("div", { className: styles.loading },
                    React.createElement("div", { className: styles.cssloader },
                        React.createElement("ul", null,
                            React.createElement("li", null),
                            React.createElement("li", null),
                            React.createElement("li", null),
                            React.createElement("li", null))),
                    React.createElement("span", { className: styles.fetchingText }, "Generating Report")))));
    }
}
